export class Service {
  number: string;
  title: string;
  text: string;
  constructor(data: Service) {
    this.number = data.number;
    this.title = data.title;
    this.text = data.text;
  }
}

export const Services : Service[] = [
  new Service({
    number: '01',
    title: 'ТРЕНИРОВКА С ИНОСТРАННЫМ СПЕЦИАЛИСТОМ',
    text: 'Персональные тренировки с сертифицированным тренером иностранных сборных и основателем детской хоккейной академии',
  }),
   new Service({
    number: '02',
    title: 'Занятия по общей физической подготовке',
    text: 'Тщательно разработанные тренировки с учетом возрастных особенностей, направленные на достижение максимальной эффективности в развитии физических качеств, соответствующих конкретной возрастной группе.',
  }),
   new Service({
    number: '03',
    title: 'Личные рекомендации',
    text: 'Создание руководств по самостоятельным тренировкам для игроков: улучшение навыков и физической подготовки на основе ваших личных показателей.',
  }),
   new Service({
    number: '04',
    title: 'Рекомендации от профессиональных диетологов',
    text: 'Примеры планов питания игроков НХЛ',
  }),
   new Service({
    number: '05',
    title: 'Мастер класс от профессионального хоккеиста',
    text: 'Показательное выступление игрока мирового уровня',
  }),
   new Service({
    number: '06',
    title: 'Удобства на льду',
    text: 'Наличие собственных: раздевалок, сушилок, оборудования для тренировок. Предоставление личных: джерси, гетр и формы для ОФП',
  }),
];
